import TestUserApi from '@apis/test/TestUserApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const testUserQueries = createQueryKeys('testUser', {
    isTestUser: () => ({
        queryKey: ['isTestUser'],
        queryFn: () => TestUserApi.isTestUser(),
    }),
});

export default testUserQueries;
